/* Bundle tiers drive the product form's QUANTITY, so an order is one SKU x N.
   That keeps fulfilment (CJ and friends) and the Merchant Center feed sane,
   where sibling Single/Duo/Trio variants would confuse both. */
(function () {
  function form(bundle) {
    return bundle.closest('.product__info-container') || document;
  }

  function quantityInput(bundle) {
    var scope = form(bundle);
    return (
      scope.querySelector('.quantity__input') ||
      scope.querySelector('input[name="quantity"]')
    );
  }

  /* The Shop Pay instalments widget is also a form posting to /cart/add and it
     sits FIRST in the DOM, so a plain action selector grabs the wrong one and
     the quantity never reaches the cart. Match the real one explicitly. */
  function cartForm(bundle) {
    var scope = form(bundle);
    return (
      scope.querySelector('form[data-type="add-to-cart-form"]') ||
      scope.querySelector('product-form form[action*="/cart/add"]') ||
      Array.prototype.slice
        .call(scope.querySelectorAll('form[action*="/cart/add"]'))
        .filter(function (f) {
          return !f.classList.contains('installment');
        })
        .pop()
    );
  }

  function apply(bundle, radio) {
    var qty = parseInt(radio.dataset.quantity, 10) || 1;
    var input = quantityInput(bundle);
    if (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      // No visible quantity field: carry it on a hidden input the form posts.
      var f = cartForm(bundle);
      if (!f) return;
      var hidden = f.querySelector('input[name="quantity"].aeloo-bundle-qty');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'quantity';
        hidden.className = 'aeloo-bundle-qty';
        f.appendChild(hidden);
      }
      hidden.value = qty;
    }
  }

  /* Arming a discount code from an AJAX cart is not supported by Shopify.
     /discount/CODE sets it for the session and is the closest thing that
     works; it can still be refused, which is why automatic discounts are the
     recommended route. */
  function armCode(bundle, radio) {
    if (bundle.dataset.applyCode !== 'true') return;
    var code = radio.dataset.code;
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
    }).catch(function () {});
  }

  /* ---------- per-unit variants ----------
     A tier whose units are all the same variant is still one SKU x N and keeps
     the plain quantity path, dynamic checkout included. The moment two units
     differ it cannot be expressed as one line, so the submit is intercepted and
     sent to /cart/add.js as an items array instead, and the dynamic checkout
     button is hidden because it can only ever carry a single variant. */
  function activeRow(bundle) {
    var checked = bundle.querySelector('.aeloo-bundle__input:checked');
    return checked ? checked.closest('.aeloo-bundle__row') : null;
  }

  function unitSelects(bundle) {
    var row = activeRow(bundle);
    if (!row) return [];
    return Array.prototype.slice.call(row.querySelectorAll('.aeloo-bundle__variant'));
  }

  function chosen(bundle) {
    return unitSelects(bundle).map(function (sel) {
      return sel.value;
    });
  }

  function mixed(bundle) {
    var ids = chosen(bundle);
    if (ids.length < 2) return false;
    return ids.some(function (id) {
      return id !== ids[0];
    });
  }

  /* The row already prints one thumbnail per unit, in the place the design
     put them. Each one follows its own dropdown rather than being replaced by
     a second strip of pictures. */
  function setThumb(img, src) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }

  /* Pictures for variants that have no dropdown of their own - the single tier,
     and any row while per-unit choice is off. Read once from the option list. */
  function imageFor(bundle, id) {
    var opt = bundle.querySelector('.aeloo-bundle__variant option[value="' + id + '"]');
    return opt ? opt.getAttribute('data-image') : null;
  }

  function syncThumbs(bundle) {
    var mainId = currentVariantId(bundle);
    var mainSrc = mainId ? imageFor(bundle, mainId) : null;
    bundle.querySelectorAll('.aeloo-bundle__row').forEach(function (row) {
      var sels = row.querySelectorAll('.aeloo-bundle__variant');
      var thumbs = row.querySelectorAll('.aeloo-bundle__thumbs img');
      if (sels.length) {
        sels.forEach(function (sel, i) {
          var opt = sel.options[sel.selectedIndex];
          setThumb(thumbs[i], opt && opt.getAttribute('data-image'));
        });
      } else {
        thumbs.forEach(function (t) {
          setThumb(t, mainSrc);
        });
      }
    });
  }

  function dynamicButton(bundle) {
    return form(bundle).querySelector('.shopify-payment-button');
  }

  function syncDynamicButton(bundle) {
    var btn = dynamicButton(bundle);
    if (!btn) return;
    /* Hidden for any multi-unit tier that offers per-unit variants: even when
       the units happen to match, the button would submit the main picker's
       variant rather than the one chosen here. */
    btn.hidden = unitSelects(bundle).length > 1;
  }

  function itemsFor(bundle) {
    var counts = {};
    chosen(bundle).forEach(function (id) {
      counts[id] = (counts[id] || 0) + 1;
    });
    return Object.keys(counts).map(function (id) {
      return { id: Number(id), quantity: counts[id] };
    });
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* Liquid stamps `is-empty` on the <cart-drawer> host itself when the cart is
     empty, and Dawn's renderContents only ever clears it from .drawer__inner.
     Replacing the section markup therefore leaves the host stale: the items are
     in the DOM but `cart-drawer.is-empty .drawer__header` and
     `.is-empty .cart__contents` keep them hidden, and open() then hunts for the
     empty-state element, finds null and throws out of trapFocus.
     Same toggle Dawn itself uses in cart.js. */
  function setEmptyState(itemCount) {
    var empty = itemCount === 0;
    ['cart-drawer', 'cart-drawer-items', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.classList.toggle('is-empty', empty);
    });
  }

  function submitMixed(bundle, event) {
    var items = itemsFor(bundle);
    if (items.length < 2) return; // nothing mixed, let the form go
    event.preventDefault();

    var drawer = cartDrawer();
    var btn = form(bundle).querySelector('.product-form__submit');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    /* Asking /cart/add.js for the sections alongside a multi-item add returns
       markup Dawn's renderContents cannot line up, and the drawer came back
       with its body blank. Adding first and then requesting the sections on
       their own gives exactly the shape it expects. */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (!drawer || !drawer.renderContents) throw new Error('no drawer');
        var ids = drawer.getSectionsToRender().map(function (s) {
          return s.id;
        });
        /* A plain GET here gets cached, and every later add re-rendered the
           drawer from the empty-cart copy - which is why it only looked right
           after a reload. */
        return Promise.all([
          fetch('/?sections=' + ids.join(',') + '&_=' + Date.now(), { cache: 'no-store' }).then(
            function (r2) {
              return r2.json();
            }
          ),
          fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (r3) {
            return r3.json();
          }),
        ]).then(function (res) {
          /* Before renderContents, because its open() runs a focus trap that
             reads the empty-state element and would still see the stale class. */
          setEmptyState(res[1].item_count);
          drawer.renderContents({ sections: res[0] });
        });
      })
      .catch(function () {
        window.location = '/cart';
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-disabled');
      });
  }

  /* The product form's hidden id field is what Dawn rewrites when the main
     picker changes, so it is the one reliable source for "which variant is
     selected now" - no option-name decoding needed. */
  function currentVariantId(bundle) {
    var f = cartForm(bundle);
    var hidden = f && f.querySelector('input[name="id"]');
    return hidden ? hidden.value : null;
  }

  function adoptMainVariant(bundle) {
    var id = currentVariantId(bundle);
    if (!id || bundle.dataset.lastVariant === id) return;
    bundle.dataset.lastVariant = id;
    bundle.querySelectorAll('.aeloo-bundle__variant').forEach(function (sel) {
      if (sel.querySelector('option[value="' + id + '"]')) sel.value = id;
    });
    syncThumbs(bundle);
  }

  function setup(bundle) {
    if (bundle.dataset.aelooReady === '1') return;
    bundle.dataset.aelooReady = '1';

    var checked = bundle.querySelector('.aeloo-bundle__input:checked');
    if (checked) apply(bundle, checked);
    syncDynamicButton(bundle);
    adoptMainVariant(bundle);
    syncThumbs(bundle);

    /* Dawn swaps the variant through the section rendering API, so the hidden
       field is still stale when the change event fires - watch the field. */
    if ('MutationObserver' in window) {
      var hidden = cartForm(bundle) && cartForm(bundle).querySelector('input[name="id"]');
      if (hidden) {
        new MutationObserver(function () {
          adoptMainVariant(bundle);
        }).observe(hidden, { attributes: true, attributeFilter: ['value'] });
      }
    }
    form(bundle).addEventListener('change', function (event) {
      if (event.target.closest('.aeloo-bundle')) return;
      setTimeout(function () {
        adoptMainVariant(bundle);
      }, 0);
    });

    bundle.addEventListener('change', function (event) {
      var radio = event.target.closest('.aeloo-bundle__input');
      if (radio && radio.checked) {
        apply(bundle, radio);
        armCode(bundle, radio);
        syncDynamicButton(bundle);
        syncThumbs(bundle);
        return;
      }
      if (event.target.classList.contains('aeloo-bundle__variant')) {
        syncThumbs(bundle);
      }
    });

    /* Clicking a dropdown inside the row must not re-pick the tier. */
    bundle.addEventListener('click', function (event) {
      if (event.target.closest('.aeloo-bundle__units')) event.stopPropagation();
    });

    var f = cartForm(bundle);
    if (f && !f.dataset.aelooBundleBound) {
      f.dataset.aelooBundleBound = '1';
      f.addEventListener(
        'submit',
        function (event) {
          if (!mixed(bundle)) return;
          /* Dawn binds its own submit in the bubble phase and runs whatever we
             do here, so preventDefault alone is not enough - it would post the
             form as one variant x N on top of our items call. */
          event.stopImmediatePropagation();
          submitMixed(bundle, event);
        },
        true
      );
    }
  }

  function init() {
    document.querySelectorAll('[data-aeloo-bundle]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
